import { Row, Col, Button } from 'reactstrap';
import Icon from '../../../assets/icons/Icon';
import Modal from '../../../components/modal/Modal';
import { useDict } from '../../../contexts/LanguageContext';

const StatementOptionModal = (props) => {
    const {
        handleClose,
        isOpen,
        openQuarterStatementModal,
        openAnnualStatementModal,
    } = props;

    const dict = useDict();

    return (
        <Modal
            isOpen={isOpen}
            toggle={handleClose}
            title={dict.myStatements}
            headerType="review-2"
            testID="statementOptionModal"
            onCancel={handleClose}
            cancelText={dict.close}
        >
            <div className="modal__body" data-cy="modal__content">
                <Row className="justify-content-center pt-2">
                    <Col xs={12}>
                        <Button
                            className="w-100 p-3 text-left border-0 d-flex justify-content-between align-items-center"
                            color="primary"
                            style={{
                                backgroundImage:
                                    'linear-gradient(to right, #4054B7 , #4972DD)',
                                outline: 'none',
                            }}
                            data-cy="quarterlyStatement__btn"
                            onClick={openQuarterStatementModal}
                        >
                            <p className="font-weight-bold text-white mr-3">
                                {dict.quarterlyStatements}
                            </p>
                            <Icon
                                icon="ChevronRight"
                                className="m-0 w-auto h-auto"
                                width={25}
                            />
                        </Button>
                    </Col>
                    <Col xs={12}>
                        <Button
                            className="w-100 p-3 text-left border-0 d-flex justify-content-between align-items-center"
                            color="primary"
                            style={{
                                backgroundImage:
                                    'linear-gradient(to right, #276DF4 , #4093F5)',
                                outline: 'none',
                            }}
                            data-cy="annualStatement__btn"
                            onClick={openAnnualStatementModal}
                        >
                            <p className="font-weight-bold text-white mr-3">
                                {dict.annualStatements}
                            </p>
                            <Icon
                                icon="ChevronRight"
                                className="m-0 w-auto h-auto"
                                width={25}
                            />
                        </Button>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};

export default StatementOptionModal;
